<template>
  <div class="photo">
    <!-- 密送 -->
    <div
      class="bc-list"
      v-if="alllist.bcPhoto"
    >
      <el-popover
        trigger="hover"
        placement="top"
        v-for="(photo, index) in alllist.bcPhoto"
        :key="index"
      >
        <!-- 插入 -->
        <div class="nest">
          <div class="nest-name">{{ photo.nickname || '' }}</div>
          <div class="nest-site">
            <div class="mailbox">{{ photo.mailbox }}</div>
            <div class="privateMailbox">{{ photo.privateMailbox }}</div>
          </div>
        </div>
        <!-- 嵌套 -->
        <div
          class="user-info"
          slot="reference"
        >
          <div class="photo">
            <img
              v-if="photo.headUrl"
              :src="photo.headUrl"
            />
            <img
              v-else
              src="@/assets/default.png"
            />
          </div>
          <div
            class="name"
            v-if="photo.name"
          >{{ photo.nickname || '' }}</div>
        </div>
      </el-popover>
    </div>

    <!-- 抄送 -->
    <div
      class="cc-list"
      v-if="alllist.ccPhoto"
    >
      <el-popover
        trigger="hover"
        placement="top"
        v-for="(photo, index) in alllist.ccPhoto"
        :key="index"
      >
        <!-- 插入 -->
        <div class="nest">
          <div class="nest-name">{{ photo.nickname || '' }}</div>
          <div class="nest-site">
            <div class="mailbox">{{ photo.mailbox }}</div>
            <div class="privateMailbox">{{ photo.privateMailbox }}</div>
          </div>
        </div>
        <!-- 嵌套 -->
        <div
          class="user-info"
          slot="reference"
        >
          <div class="photo">
            <img
              v-if="photo.headUrl"
              :src="photo.headUrl"
            />
            <img
              v-else
              src="@/assets/default.png"
            />
          </div>
          <div
            class="name"
            v-if="photo.name"
          >{{ photo.nickname || '' }}</div>
        </div>
      </el-popover>
    </div>

    <div v-if="showImg">-</div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {}
  },
  computed: {
    src() {
      return this.scope.row[this.tableData.bind]
    },
    popover() {
      return this.tableData.popover || false
    },
    alllist() {
      return this.tableData.photoList(this.scope.row, this.tableData)
    },
    showImg() {
      return this.alllist.length == 0 ? true : false
    }
  },
  methods: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.photo {
  width: 100%;
  height: 100%;
  .bc-list,
  .cc-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // 单行溢出
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // flex-wrap: wrap;
  }
  .bc-list {
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .cc-list {
    padding-top: 7px;
    padding-bottom: 8px;
  }
}

.user-info {
  padding: 5px 10px;
  text-align: center;
  .photo {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.nest-site {
  .privateMailbox,
  .mailbox {
    margin: 3px 0px;
  }
}
</style>
